// extracted by mini-css-extract-plugin
export default {"form":"Login_form__UohUC","group":"Login_group__1HOKr","logged":"Login_logged__dX4Yt","loading":"Login_loading__-o0Vz"};